import { SignUpStagesView } from './SignUpStagesView'
import { FC, useMemo } from 'react'

type SignUpStagesProps = {
  position: number
  className?: string
}

const defaultStagesList = [
  {
    title: 'Server Rules',
  },
  {
    title: 'Enter Credentials',
  },
  {
    title: 'Verification',
  },
]
export const SignUpStages: FC<SignUpStagesProps> = ({
  position,
  className,
}) => {
  const stagesList = useMemo(
    () =>
      defaultStagesList.map((stage, index) => {
        return {
          ...stage,
          isActive: index === position - 1,
          isCompleted: index < position - 1,
        }
      }),
    [position],
  )

  return <SignUpStagesView list={stagesList} className={className} />
}
